import { Supervisor } from '../../domain/supervisor/Supervisor';
import { SupervisorActionType, SupervisorActions } from './actions';
import { SupervisorsTableColumn, getSupervisorsTableColumns, setSupervisorsTableColumns } from './tableColumns';

export interface SupervisorState {
  supervisors: Supervisor[];
  tableColumns: Array<SupervisorsTableColumn>;
}

export const getInitialState = (): SupervisorState => ({
  supervisors: [],
  tableColumns: getSupervisorsTableColumns(),
});

export const SupervisorReducer = (state: SupervisorState, action: SupervisorActions): SupervisorState => {
  switch (action.type) {
    case SupervisorActionType.SET_SUPERVISORS_TABLE_COLUMNS:
      setSupervisorsTableColumns(action.payload);
      return {
        ...state,
        tableColumns: action.payload,
      };
    case SupervisorActionType.SEARCH_SUPERVISORS_SUCCESS:
      return {
        ...state,
        supervisors: action.payload.supervisors,
      };
    default:
      return state;
  }
};
